import { Button, Spinner } from '@design-system';
import { useTranslation } from 'next-i18next';

import { pathFor } from '../../../helpers/links';
import { OrderReviewPreview } from '../OrderReview';
import { IdentityVerificationCard } from './ui/IdentityVerificationCard';

export type SuccessStatus = 'confirming' | 'confirmed';

export type SuccessProps = {
  isPreorder: boolean;
  artistName: string;
  identityVerificationRequired?: boolean;
  numberOfDraws?: number;
  status?: SuccessStatus;
  winUpTo?: number;
  images: {
    id: string;
    src: string;
    alt: string;
  }[];
};

export const Success = ({
  artistName,
  identityVerificationRequired = false,
  images,
  isPreorder = false,
  numberOfDraws,
  status = 'confirmed',
  winUpTo,
}: SuccessProps) => {
  const { t } = useTranslation('checkout');

  if (status === 'confirming') {
    return (
      <div className="mt-6 flex w-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-12">
      <h2 className="text-center text-md font-bold text-neutral-6 md:text-lg">
        {t(`success.${isPreorder ? 'preorder' : 'draw'}.title`)}
      </h2>

      <span className="text-center">
        {t(`success.${isPreorder ? 'preorder' : 'draw'}.body`, {
          artistName,
          numberOfDraws,
          winUpTo,
        })}
      </span>

      {identityVerificationRequired ? (
        <IdentityVerificationCard />
      ) : (
        <Button
          as="a"
          fullWidth
          href={pathFor({ page: 'RELEASES_INDEX' })}
          label={t('success.discover')}
          variant="primary"
        />
      )}

      <OrderReviewPreview images={images} />
    </div>
  );
};
